import PropTypes from "prop-types";
import { parseHtml } from "../../utils/utils";
import "../../styles/styles.scss";

const UnderstandTaxBillDoc = ({ content }) => {

    return (
        content && (
            <div className="supplemental-bill-sample-info-boxes">

                <map name="FPMap0">
                    <area
                        shape="rect"
                        coords="20, 248, 112, 282"
                        title="This is your APN (Assessors Parcel Number), which is a unique number assigned to your property."
                        alt="APN"
                    />
                    <area
                        shape="rect"
                        coords="20, 613, 125, 647"
                        title="This is your APN (Assessors Parcel Number), which is a unique number assigned to your property."
                        alt="APN"
                    />
                    <area
                        shape="rect"
                        coords="20, 890, 125, 900"
                        title="This is your APN (Assessors Parcel Number), which is a unique number assigned to your property."
                        alt="APN"
                    />
                    <area
                        shape="rect"
                        coords="112, 248, 177, 282"
                        title="This is the unique tax bill number assigned to your property each year."
                        alt="Tax Bill Number"
                    />
                    <area
                        shape="rect"
                        coords="144, 613, 215, 647"
                        title="This is the unique tax bill number assigned to your property each year."
                        alt="Tax Bill Number"
                    />
                    <area
                        shape="rect"
                        coords="125, 890, 210, 905"
                        title="This is the unique tax bill number assigned to your property each year."
                        alt="Tax Bill Number"
                    />
                    <area
                        shape="rect"
                        coords="215, 890, 315, 900"
                        title="This is the date that the bill will become delinquent after."
                        alt="Tax Rate Area"
                    />
                    <area
                        shape="rect"
                        coords="190, 613, 315, 647"
                        title="This is the date that the bill will become delinquent after."
                        alt="Tax Rate Area"
                    />
                    <area
                        shape="rect"
                        coords="215, 248, 280, 282"
                        title="This is the tax rate area for your property.&nbsp; This is one of the components that determine the amount of taxes on your property."
                        alt="Tax Rate"
                    />
                    <area
                        shape="rect"
                        coords="20, 340, 159, 383"
                        title="This is the situs or physical address of the property.&nbsp; (If there are no improvements to the property this may be blank)"
                        alt="Property Address"
                    />
                    <area
                        shape="rect"
                        coords="20, 293, 159, 336"
                        title="This is the legal owner(s) of the record as of January 1."
                        alt="Legal Owner"
                    />
                    <area
                        shape="rect"
                        coords="220, 190, 390, 285"
                        title="This is the date that the first installment of taxes is due."
                        alt="First Installment Due Date"
                    />
                    <area
                        shape="rect"
                        coords="390, 120, 510, 285"
                        title="This is the date that the second installment of taxes is due."
                        alt="Second Installment Due Date"
                    />
                    <area
                        shape="rect"
                        coords="370, 895, 490, 910"
                        title="Deadline to pay tax amount without penalty."
                        alt="Deadline"
                    />
                    <area
                        shape="rect"
                        coords="370, 600, 490, 647"
                        title="Deadline to pay tax amount without penalty."
                        alt="Deadline"
                    />
                    <area
                        shape="rect"
                        coords="535, 248, 625, 282"
                        title="This is the total tax amount - from the first and second installments - due and payable. This amount is valid if paid before the delinquent dates."
                        alt="Total Tax Amount"
                    />
                    <area
                        shape="rect"
                        coords="495, 895, 640, 945"
                        title="This is the amount due if property taxes are paid after the deadline."
                        alt="Amount Due After Deadline"
                    />
                    <area
                        shape="rect"
                        coords="495, 590, 640, 645"
                        title="This is the amount due if property taxes are paid after the deadline."
                        alt="Amount Due After Deadline"
                    />
                    <area
                        shape="rect"
                        coords="334, 292, 633, 535"
                        title="This area shows the breakdown of your tax bill by agency receiving your tax dollars. If you have questions regarding any of the amounts, you should contact them directly."
                        alt="Tax Bill Breakdown"
                    />
                    <area
                        shape="rect"
                        coords="20, 392, 318, 422"
                        title="Legal description of the property."
                        alt="Legal Description"
                    />
                    <area
                        shape="rect"
                        coords="20, 425, 318, 495"
                        title="Additional notes regarding your tax bill or property."
                        alt="Additional Notes"
                    />
                    <area
                        shape="rect"
                        coords="334, 150, 634, 250"
                        title="This is the taxable value of your property."
                        alt="Taxable Value"
                    />
                </map>

                <div>
                    <img
                        src={parseHtml(content.contentImageUrl)}
                        alt="understadning your tax bill"
                        usemap="#FPMap0"
                        width="650"
                        height="1073"
                        style={{ display: "block", "margin-left": "auto", "margin-right": "auto" }}
                    />
                </div>
            </div>
        )
    );
};

UnderstandTaxBillDoc.propTypes = {
    content: PropTypes.shape({
        contentImageUrl: PropTypes.string.isRequired
    }).isRequired
};

export default UnderstandTaxBillDoc;
